import Input from "components/Input";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useEffect, useMemo, useRef, useState } from "react";
import TerytService, { IZipCode } from "api/TerytService";
import { useDebounce } from "use-debounce";
import { useOnClickOutside } from "usehooks-ts";

const SearchCode: FC<Props> = ({
  id,
  isError = "",
  onChange,
  defaultValue,
  onBlur,
}) => {
  const [value, setValue] = useState(defaultValue.toString() ?? "");
  const [searchList, setSearchList] = useState<any[]>([]);

  const [ss, setSearchValue] = useState("");
  const [searchValue] = useDebounce(ss, 300);

  const { data: zipData } = TerytService.useGetZipCode(searchValue);
  const zipCodes: IZipCode[] = useMemo(() => zipData?.data ?? [], [zipData]);
  useEffect(() => {
    const list = zipCodes.map((zip) => zip.Value);

    if (value.length === 0) return;
    setSearchList(list);

    if (list.length === 1) {
      setValue(list[0]);
      onChange(list[0]);
      setSearchList([]);
    }
  }, [searchValue, zipCodes]);

  const handleClick = (zip: string) => {
    setValue(zip);
    onChange(zip);
    setSearchList([]);
  };

  useEffect(() => {
    setValue(defaultValue.toString());
  }, [defaultValue]);

  const [focused, setFocused] = useState(false);

  const outsideRef = useRef(null);

  useOnClickOutside(outsideRef, () => {
    if (focused) {
      setFocused(false);
    }
  });

  return (
    <div ref={outsideRef} className={`${styles.wrapper}`}>
      <Input
        id={id}
        onFocus={() => {
          setFocused(true);
        }}
        onBlur={() => {
          if (searchList.length === 1 && value.length > 0) {
            handleClick(searchList[0]);
          }

          onBlur?.();
        }}
        isError={isError}
        value={value}
        onChange={(text) => {
          setValue(text);
          setSearchValue(text);
        }}
        label="Kod pocztowy"
        inputProps={{
          "data-1p-ignore": "",
          "data-op-ignore": "",
        }}
      />
      {!!searchList.length && !!value.length && focused && (
        <div className={styles.list}>
          <div className={styles.listWrapper}>
            {searchList.map((zip: string) => (
              <div
                onClick={() => handleClick(zip)}
                key={zip}
                className={styles.box}
              >
                {zip}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchCode;
